import { post_data } from "../helpers/functions.js";
import toastr_show from "../helpers/toastr_options.js";
import Modal from "./modal.js";
import { isUserAdmin, isUserEditor} from "../helpers/is_user_.js";

export default class ProjectList extends Modal {

  static type = "Project";
  static container = document.querySelector(".inner-page__layout-container");
  constructor(data) {
    super(data);
    this.data = data;
    this.count = 0;
  }

  display_data() {
    const projects_layout_style = localStorage.getItem(
      "projects_display_style"
    );
    this.displayRecentProjects();
    if (projects_layout_style === "list") {
      ProjectList.container.classList.add("inner-page__layout-container-list");
      ProjectList.container.classList.remove("d-flex");
      ProjectList.container.innerHTML = this.list_layout();
      return;
    }
    ProjectList.container.classList.remove("inner-page__layout-container-list");
    ProjectList.container.classList.add("d-flex");
    ProjectList.container.innerHTML = this.grid_layout();
  }

  displayRecentProjects = async () => {
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "get_recent_projects",
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    if (!response) {
      document.getElementById("recent-projects").remove();
      document.getElementById("recent-project-heading").remove();
      return;
    }
    document.getElementById("recent-projects").innerHTML = this.grid_layout(response); // prettier-ignore
  };

  grid_layout = (data = this.data) => {
    let div = "";
    if (!data) return div;
    for (let item of data) {
        const imagePath = item["image_path"]
            ? `uploads/files/${item["image_path"]}`
            : "";
        const renderImage = imagePath
            ? `<img src="${imagePath}" class="w-100" alt="" />`
            : "";
        const templateLabel = item["is_template"] == 1 ? '<span class="template-label"> (Template)</span>' : '';
        div += `<div class="inner-page__layout-item" data-id="${item["id"]}">
                <div class="layout-item__content">
                    <a href="editor?project=${
                    item["id"]
                    }" class="layout-item__content--image">
                        ${renderImage}
                    </a>
                    ${this.grid_buttons_display(item)}
                </div>
                
                <a href="editor?project=${
                item["id"]
                }" class="layout-item__top-name"> <span class="top-name-text">Project: ${
                    item["name"] ?? "&nbsp;"
                }</span>${templateLabel}</a>
                </div>`;
    }
    return div;
};


grid_buttons_display = (data) => {
  let div = "";
  const { status } = data;

  // Check if the user is an admin or editor
  const canEditOrDelete = isUserAdmin() || isUserEditor();

  if (status !== "111") {
    div += `<div class="layout-item__buttons d-flex justify-content-space-between align-items-center">
               ${status === "9" ? '<span class="layout-item__button--lock"> <i class="fas fa-lock"></i> </span>' : ""}
              <a href="./editor?project=${data["id"]}" class=" layout-item__button share" data-id="${data["id"]}"> <i class="fas fa-share-alt share"></i> </a>`;
    
    // Conditionally display the delete (archive) button for admin or editor
    if (canEditOrDelete) {
      div += `<a href="" class=" layout-item__button archive" data-id="${data["id"]}"><i class="fas fa-trash archive"></i></a>`;
    }

    div += `<a href="" class=" layout-item__button dropdown-toggle-link dropdown-toggle"><i class="fas fa-ellipsis-h dropdown-toggle"></i></a>
              <div class="layout-item__dropdown">`;

    // Edit button (visible to everyone)
    div += `<a href="editor?project=${data["id"]}" class="layout-item__dropdown-item"> <img src="./uploads/images/edit.png" class="layout-item__dropdown-icon" alt="edit" > 
            ${status === "9" ? "View" : "Edit"} </a>`;

    // Download button (no restrictions)
    div += `<a href="pdf-document.php?id=${data["id"]}" class="layout-item__dropdown-item" target="_blank" rel="noopener noreferrer"> <img src="./uploads/images/download.png" class="layout-item__dropdown-icon" alt="download" > Download </a>`;

    // Conditionally display the Rename button for admin or editor
    if (canEditOrDelete) {
      div += `<a href="editor?project=${data["id"]}" class="layout-item__dropdown-item rename" data-name="${data["name"]}"> <img src="./uploads/images/rename.png" class="layout-item__dropdown-icon" alt="rename" > Rename </a>`;
    }

    // Conditionally display the Duplicate button for admin or editor
    if (canEditOrDelete) {
      div += `<a href="" class="layout-item__dropdown-item duplicate" data-id="${data["id"]}"> <svg id="duplicate-icon" class="layout-item__dropdown-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24"><rect width="13" height="13" x="4" y="4" fill="#aaa"/><rect width="13" height="13" x="10" y="10" fill="#aaa"/></svg> Duplicate </a>`;
    }

    // Conditionally display the Duplicate All button for admin or editor
    if (canEditOrDelete) {
      div += `<a href="" class="layout-item__dropdown-item duplicate-all" data-id="${data["id"]}"> <svg id="duplicate-all-icon" class="layout-item__dropdown-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24"><rect width="13" height="13" x="4" y="4" fill="#aaa"/><rect width="13" height="13" x="8" y="8" fill="#aaa"/><rect width="13" height="13" x="12" y="12" fill="#aaa"/></svg> Duplicate All </a>`;
    }

    // Conditionally display the Create Template button for admin or editor
    if (canEditOrDelete) {
      div += `<a href="" class="layout-item__dropdown-item create-template" data-id="${data["id"]}"> <svg id="create-template-icon" class="layout-item__dropdown-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24"><rect width="20" height="28" x="4" y="2" fill="#aaa"/><circle cx="18" cy="6" r="2" fill="#aaa"/></svg> Create Template </a>`;
    }

    div += `</div></div>`;
  } else {
    // Conditionally display the Restore button for admin or editor
    if (canEditOrDelete) {
      div += `<div class="layout-item__buttons d-flex justify-content-center align-items-center">
                <a href="" class="btn btn-primary layout-item__button restore" data-id="${data["id"]}">Restore</a>
            </div>`;
    }
  }

  return div;
};
  

  list_layout = () => {
    return `${this.list_layout_header()} ${this.list_layout_body()}`;
  };

  list_layout_header = () => {
    return `<div class="inner-page__layout-list-item">
            <div class="inner-page__layout-list-headings w-100 d-flex align-items-center">
                <h3 class="layout-list-item__heading">Name</h3>
                <h3 class="layout-list-item__heading">Photo</h3>
                <h3 class="layout-list-item__heading">Last modified</h3>
                <div class="w-25"></div>
            </div>`;
  };

  list_layout_body = () => {
    let div = '<div class="layout-list-item__data-container">';
    for (let data of this.data) {
      const templateLabel = data["is_template"] == 1 ? '<span class="template-label"> (Template)</span>' : '';
      div += `<div class="layout-list-item__data d-flex align-items-center w-100" data-link="./editor?project=${
        data["id"]
      }" data-id="${data["id"]}">
                        <h4 class="layout-list-item__data-text w-25">Project: ${
                          data["name"]
                        } ${templateLabel}</h4>
                        <h4 class="layout-list-item__data-text w-25">

                        <img src="./uploads/files/${
                          data["image_path"]
                        }" class="layout-list-item__data-image" alt="" />
                        </h4>
                        <h4 class="layout-list-item__data-text w-25">${
                          data["date"]
                        }</h4>
                        ${this.list_buttons_display(data)}
                    </div>`;
    }
    div += "</div></div>";
    return div;
  };

  list_buttons_display = (data) => {
    let div = "";
    const { status } = data;
  
    // Check if the user is an admin or editor
    const canEditOrDelete = isUserAdmin() || isUserEditor();
  
    if (status !== "111") {
      div += `<div class="layout-list-item__buttons w-25">
                  <a href="./editor?project=${data["id"]}" class=" layout-item__button" data-id="${data["id"]}"> <i class="fas fa-share-alt share"></i> </a>`;
  
      // Conditionally display the delete (archive) button for admin or editor
      if (canEditOrDelete) {
        div += `<a href="" class=" layout-item__button" data-id="${data["id"]}"><i class="fas fa-trash archive"></i></a>`;
      }
  
      div += `<a href="" class=" layout-item__button dropdown-toggle-link"><i class="fas fa-ellipsis-h dropdown-toggle"></i></a>
                <div class="layout-item__dropdown">`;
  
      // Edit button (visible to everyone)
      div += `<a href="editor?project=${data["id"]}" class="layout-item__dropdown-item"> <img src="./uploads/images/edit.png" class="layout-item__dropdown-icon" alt="edit" > ${status === "9" ? "View" : "Edit"} </a>`;
  
      // Download button (no restrictions)
      div += `<a href="pdf-document.php?id=${data["id"]}" class="layout-item__dropdown-item" target="_blank" rel="noopener noreferrer"> <img src="./uploads/images/download.png" class="layout-item__dropdown-icon" alt="download" > Download </a>`;
  
      // Conditionally display the Rename button for admin or editor
      if (canEditOrDelete) {
        div += `<a href="editor?project=${data["id"]}" class="layout-item__dropdown-item rename" data-name="${data["name"]}"> <img src="./uploads/images/rename.png" class="layout-item__dropdown-icon" alt="rename" > Rename </a>`;
      }
  
      div += `</div></div>`;
    } else {
      // Conditionally display the Restore button for admin or editor
      if (canEditOrDelete) {
        div += `<div class="layout-list-item__buttons d-flex align-items-center w-25">
                  <a href="" class="btn btn-primary-outline restore" data-id="${data["id"]}">Restore</a>
              </div>`;
      }
    }
  
    return div;
  };


  toggleDropdown = (e) => {
    if (
      e.target.classList.contains("dropdown-toggle") &&
      e.target.parentElement.classList.contains("active")
    ) {
      e.preventDefault();
      e.target.parentElement.classList.remove("active");
      return;
    }
    document
      .querySelector(".dropdown-toggle-link.active")
      ?.classList.remove("active");
    if (!e.target.classList.contains("dropdown-toggle")) {
      return;
    }
    e.preventDefault();
    const container = e.target.parentElement;
    container.classList.add("active");
  };

  createNewProject = async (e) => {
    if (!e.target.classList.contains("add")) return;
    let name_available = await this.nameAvailable();
    if (!name_available) return;

    const projectName = document.querySelector(".modal__body-input").value;
    const projectTemplateID = document.querySelector(".template-select").value;

    if(projectTemplateID != 0){
      let id = await this.duplicateForNewProject(projectName, projectTemplateID);
      const newLocation = location.href.split("projects")[0] + "editor?project=" + id;
      location.href = newLocation;
      return;
    }else{
      const newLocation = location.href.split("projects")[0] + "editor?name=" + projectName;
      location.href = newLocation;
      return;
    }

    // prettier-ignore
    const newLocation = location.href.split("projects")[0] + "editor?name=" + projectName;
    location.href = newLocation;
  };

  nameAvailable = async () => {
    const projectName = document.querySelector(".modal__body-input").value;
    if (projectName === "") {
      toastr_show("error", "Please enter a project name.");
      return false;
    }

    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "check_project_name",
        name: projectName,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    if (response.status === "error") {
      toastr_show(response.status, response.message);
      document.querySelector(".modal").parentElement.remove();
      return false;
    }
    return true;
  };

  renameProject = async (e) => {
    if (!e.target.classList.contains("save")) return;
    if (! await this.nameAvailable()) return;
    const id = e.target.getAttribute("data-id");
    const projectName = document.querySelector(".modal__body-input").value;
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "change_project_name",
        id,
        value: projectName,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    toastr_show(response.status, response["message"]);
    const elements = document.querySelectorAll(
      '.inner-page__layout-item[data-id="' + id + '"] .layout-item__top-name'
    );
    if (elements) elements.forEach(element => {
      element.textContent = "Project: " + projectName;
      element.parentElement.querySelector('.rename').dataset.name = projectName;
    });
    this.data.forEach((project) => {
      if (project.id === id) project.name = projectName;
    });
    document.querySelector(".modal").parentElement.remove();
  };

  duplicateProjectFunction = async (e) => {
    if (!e.target.classList.contains("duplicate")) return;
    if (! await this.nameAvailable()) {
      return;
    }
    const id = e.target.getAttribute("data-id");
    const projectName = document.querySelector(".modal__body-input").value;
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "duplicate_project",
        id,
        value: projectName,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);

    if(response.status == "success"){
      window.location.reload();
    }else{
      toastr_show("error", "Error duplicating project.");
    }

  };

  duplicateForNewProject = async (projectName, id) => {
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "duplicate_project",
        id,
        value: projectName,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    if(response.status == "success"){
      return response.new_project_id;
    }else{
      toastr_show("error", "Error duplicating project.");
    }

  };

  duplicateProjectAllFunction = async (e) => {
    if (!e.target.classList.contains("duplicate-all")) return;
    if (! await this.nameAvailable()) return;
    const id = e.target.getAttribute("data-id");
    const projectName = document.querySelector(".modal__body-input").value;
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "duplicate_project_all",
        id,
        value: projectName,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);

    if(response.status == "success"){
      window.location.reload();
    }else{
      toastr_show("error", "Error duplicating project.");
    }

  };

  createTemplateFunction = async (e) => {
    if (!e.target.classList.contains("create-template")) return;
    if (! await this.nameAvailable()) return;
    const id = e.target.getAttribute("data-id");
    const projectName = document.querySelector(".modal__body-input").value;
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "create_template",
        id,
        value: projectName,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);

    if(response.status == "success"){
      window.location.reload();
    }else{
      toastr_show("error", "Error duplicating project.");
    }

  };
  set_data = (data) => {
    this.data = data;
  };
}
